/**
 * Cart Donation Bar - Live update functionality
 * Updates meal count with animation when cart changes
 * 
 * Logic: 0 meals empty cart, 1 meal for 1-2 items, 3 meals when B2G1F applies, 5 meals for bundle
 */

class CartDonationBar {
  constructor() {
    this.bar = document.querySelector('[data-donation-bar]');
    this.countElement = document.querySelector('[data-donation-count]');
    this.labelElement = document.querySelector('[data-donation-label]');
    this.currentCount = this.countElement ? parseInt(this.countElement.textContent) || 0 : 0;
    this.multiplier = this.bar ? parseInt(this.bar.dataset.multiplier) || 1 : 1;
  }

  updateCount(newCount) {
    if (!this.countElement) {
      this.countElement = document.querySelector('[data-donation-count]');
      if (!this.countElement) return;
    }

    const oldCount = this.currentCount;
    if (newCount === oldCount) return;

    this.countElement.classList.add('is-updating');
    this.animateValue(oldCount, newCount, 300);
    this.updateLabel(newCount);

    setTimeout(() => {
      this.countElement.classList.remove('is-updating');
    }, 400);

    this.currentCount = newCount;
  }

  updateLabel(count) {
    if (!this.labelElement) {
      this.labelElement = document.querySelector('[data-donation-label]');
    }
    if (this.labelElement) {
      this.labelElement.textContent = count === 1 ? 'MEAL' : 'MEALS';
    }
  }

  animateValue(start, end, duration) {
    const range = end - start;
    const startTime = performance.now();
    
    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentValue = Math.round(start + (range * easeOutQuart));
      
      if (this.countElement) {
        this.countElement.textContent = currentValue;
      }
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    
    requestAnimationFrame(animate);
  }

  static calculateMeals(items, multiplier = 1) {
    if (!items || !Array.isArray(items) || items.length === 0) return 0;

    const totalItems = items.reduce((total, item) => total + item.quantity, 0);
    if (totalItems === 0) return 0;

    const hasBundle = items.some(item =>
      item.handle === 'choose-your-5-jewellery-pieces-1' ||
      (item.product_title && item.product_title.toLowerCase() === 'choose your 5 jewelry pieces')
    );
    if (hasBundle) return Math.min(5 * multiplier, 5);

    const hasB2G1F = items.some(item => item.final_line_price === 0 || item.line_price === 0);
    if (hasB2G1F) return Math.min(3 * multiplier, 5);

    return Math.min(1 * multiplier, 5);
  }

  static calculateMealsFromItemCount(itemCount, multiplier = 1) {
    if (!itemCount || itemCount < 1) return 0;
    return Math.min(1 * multiplier, 5);
  }

  refresh() {
    this.bar = document.querySelector('[data-donation-bar]');
    this.countElement = document.querySelector('[data-donation-count]');
    this.labelElement = document.querySelector('[data-donation-label]');
    if (this.bar) {
      this.multiplier = parseInt(this.bar.dataset.multiplier) || 1;
    }
    if (this.countElement) {
      this.currentCount = parseInt(this.countElement.textContent) || 0;
    }
  }

  getMultiplier() {
    return this.multiplier;
  }

  fetchAndUpdate() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        this.refresh();
        const multiplier = this.getMultiplier();
        const newCount = CartDonationBar.calculateMeals(cart.items, multiplier);
        this.updateCount(newCount);
      })
      .catch(err => console.error('Donation bar cart fetch error:', err));
  }
}

window.cartDonationBar = new CartDonationBar();

function updateDonationBar(countOrItems) {
  if (!window.cartDonationBar) {
    window.cartDonationBar = new CartDonationBar();
  }

  // Always fetch fresh cart data from Shopify API to get full items with prices
  setTimeout(() => {
    window.cartDonationBar.fetchAndUpdate();
  }, 100);
}

window.updateDonationBar = updateDonationBar;

document.addEventListener('DOMContentLoaded', () => {
  window.cartDonationBar = new CartDonationBar();
});